module.exports = __webpack_public_path__ + "img/laboratorio2_16-9_640.6a171d0e.jpg";